import { countTypeEnum, OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { ItemssubLotDto } from "./item-lot-club.dto";

export class MainLotClubDto {
    mainlotNo: string;
    operation:string;
    saleOrderId: number;
    soItemId: number;
    plantId: number;
    subPlantId: number;
    purpose:string;
    remarks:string;
    subLotInfo:ItemssubLotDto[]
    availableQuantity:number;
    prevOperation?:OperationTypeEnum
    count?:number
    qtyAftClub ?: number
    year ?: number
    clubbedQuantity?: number
    newLotNumber?:string
    createdUser?: string
    newProduct?:number
    prodInvId?:number
    newCountType?:countTypeEnum
    newCount?:string

    constructor(
        mainlotNo: string,
        operation:string,
        saleOrderId: number,
        soItemId: number,
        plantId: number,
        subPlantId: number,
        purpose:string,
        remarks:string,
        subLotInfo:ItemssubLotDto[],
        availableQuantity:number,
        prevOperation?:OperationTypeEnum,
        count?:number,
        qtyAftClub ?: number,
        year ?: number,
        clubbedQuantity?: number,
        newLotNumber?:string,
        createdUser?: string,
        newProduct?:number,
        prodInvId?:number,
        newCountType?:countTypeEnum,
        newCount?:string
    )
    {
        this.mainlotNo=mainlotNo;
        this.operation=operation;
        this.saleOrderId=saleOrderId;
        this.soItemId=soItemId;
        this.plantId=plantId;
        this.subPlantId=subPlantId;
        this.purpose=purpose;
        this.remarks=remarks;
        this.subLotInfo=subLotInfo;
        this.availableQuantity=availableQuantity;
        this.prevOperation = prevOperation
        this.count = count
        this.qtyAftClub = qtyAftClub
        this.year = year
        this.clubbedQuantity = clubbedQuantity
        this.newLotNumber = newLotNumber
        this.createdUser = createdUser
        this.newProduct = newProduct
        this.prodInvId = prodInvId
        this.newCountType = newCountType
        this.newCount = newCount
    }
   
    }
